import { isDesktopSize } from '$func/environmentInfo'

export const CALL_BAR_HEIGHT = 44
export const JOIN_CHANNEL_CALL_BAR_HEIGHT = 44
export const JOIN_MEETING_BAR_HEIGHT = 44
export const JOIN_HALL_REQUESTS_BAR_HEIGHT = 40
export const PIN_VIEWER_HEIGHT = 44
export const SCHEDULED_CALL_BAR_HEIGHT = 56
export const SEND_FIELD_DEFAULT_HEIGHT = isDesktopSize() ? 64 : 56
export const SELECT_BAR_HEIGHT = SEND_FIELD_DEFAULT_HEIGHT
export const FOOTER_ACTION_BUTTON_HEIGHT = SEND_FIELD_DEFAULT_HEIGHT
export const SEND_FIELD_BORDER_TOP_COLOR = '#0000001A'
export const COURSE_VITRINE_BUTTON_HEIGHT = 48
